module.exports = __webpack_public_path__ + "img/setting_17.9a77d217.svg";